import React from 'react';
import './../styles/EmptyProfileSection.scss';
import Button from './../../../shared/components/UI/Button';
import ProfileEditModal from "../../../pages/Cabinet/components/ProfileEditModal/ProfileEditModal";
import { useState } from "react";

interface props {
    isClosedProfile?: boolean
    profileNotExists?: boolean
}

const EmptyProfileSection = ({ isClosedProfile, profileNotExists }: props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const edit = <>
        {isOpen && (
            <ProfileEditModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            ></ProfileEditModal>
        )}
        <p className="empty-profile__text">Пустой профиль</p>
        <Button className="empty-profile__button" onClick={() => setIsOpen(true)}>Редактировать</Button></>

    const closed = <p className="empty-profile__text">Данный профиль скрыт</p>

    const notExistence = <p className='empty-profile__text'>Данного профиля не существует</p>

    let content

    if (profileNotExists) {
        content = notExistence
    } else {
        content = isClosedProfile ? closed : edit
    }

    return (
        <div className="empty-profile">
            <div className="empty-profile__content">
                <div className="empty-profile__emoji">
                    <img className='empty-profile__vector' src='/EmptyProfileSection/Vector.png'></img>
                </div>
                {content}
            </div>
        </div>
    );
};

export default EmptyProfileSection;